
import BaseBtModal from "@vueEntry/BaseBtModal.vue";
import { useCommonVars } from "@wkComposables/useCommonVars";
import {IResidentialTypologies} from "@customTypes/VariableTypes";
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
import {defineComponent} from "vue";

export default defineComponent({
    name: "ValuationTypologyModal",
    components: {BaseButton, BaseBtModal},
    props: {
        showValuationTypologyModal: {
            type: Boolean,
        },
        valuationTypologyId: {
            type: Number,
            required: true
        },
        lastValuationTypologyId: {
            type: Number,
            default: 1
        },
    },
    emits: ["close-valuation-typology-modal", "selected-typology"],
    setup(){
        const {wkLabels, options} = useCommonVars()
        return {
            wkLabels,
            options
        }
    },
    data() {
        return {
            show: false,
        }
    },
    computed: {
        residentialTypologiesFiltered(): Array<IResidentialTypologies> {
            return this.options.residentialTypologiesFiltered as [] ?? [];
        }
    },
    created() {
        this.show = this.showValuationTypologyModal;
    },
    methods: {
        manageTypologySelected(valuationTypologyObj: IResidentialTypologies): void {
            this.$emit("selected-typology", valuationTypologyObj);
            this.closeModal();
        },
        isSelected(id: number): boolean {
            return this.lastValuationTypologyId == id;
        },
        closeModal(): void {
            this.show = false;
        }
    }
})
